export const COMPONENT_BG_COLOR = {
    WHITE: 'white', // White (white) #ffffff
    LIGHT_GRAY: 'light gray', // Light Gray (white-smoke) #f6f6f6
    DARK_GRAY: 'dark gray', // Charcoal (mine-shaft) #333333
    BLUE: 'blue', // Brand Blue (san-juan) #2e426b
};
